import { useEffect, useState } from "react";

export default function SummaryCards() {
    const [stats, setStats] = useState(null);

    useEffect(() => {
        const load = async () => {
            try {
                // 1. On lance les deux appels en parallèle
                const [resSummary, resQueues] = await Promise.all([
                    fetch("https://centrex.amservices.eu/api/dashboard/summary.php"),
                    fetch("https://centrex.amservices.eu/api/dashboard/queues.php")
                ]);

                const summaryData = await resSummary.json();
                const queuesData = await resQueues.json();

                // 2. On calcule le VRAI nombre d'appels actifs (comme dans l'autre fichier)
                let vraiNombreActifs = 0;

                if (queuesData) {
                    Object.values(queuesData).forEach(calls => {
                        // On ne compte que ceux qui sont vraiment en cours
                        const actifs = calls.filter(c =>
                            ['trying', 'ringing', 'connected'].includes(c.state)
                        );
                        vraiNombreActifs += actifs.length;
                    });
                }

                // 3. On fusionne les données : on garde les manqués du summary, mais on écrase le active_calls
                setStats({
                    ...summaryData,
                    active_calls: vraiNombreActifs // Ici on force notre calcul
                });

            } catch (error) {
                console.error("Erreur chargement stats", error);
                // En cas d'erreur, on met null ou on garde les anciennes stats
            }
        };

        load();
        const i = setInterval(load, 2000);
        return () => clearInterval(i);
    }, []);

    if (!stats) return null;

    return (
        <div className="summary-grid">
            <div className="summary-card">
                <h3>📞 Appels actifs</h3>
                {/* Maintenant ce chiffre sera juste car calculé par nous */}
                <strong>{stats.active_calls}</strong>
            </div>

            <div className="summary-card">
                <h3>📂 Files</h3>
                <strong>{stats.queues_count}</strong>
            </div>

            <div className="summary-card">
                <h3>📵 Manqués aujourd’hui</h3>
                <strong>{stats.missed_today}</strong>
            </div>

            <div className="summary-card">
                <h3>📊 Manqués total</h3>
                <strong>{stats.missed_total}</strong>
            </div>
        </div>
    );
}